import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ListingForm } from "@/components/listing-form";
import { supabase } from "@/integrations/supabase/client";
import type { ListingRow } from "@/lib/listings";
import { isAdmin } from "@/lib/admin";


export const Route = createFileRoute("/_authenticated/elan-redakte/$id")({
  head: () => ({
    meta: [
      { title: "Elanı redaktə et — Albazar.az" },
      { name: "description", content: "Elanınızın şəkillərini, qiymətini və məlumatlarını yeniləyin." },
      { property: "og:title", content: "Elanı redaktə et — Albazar.az" },
      { property: "og:description", content: "Elan məlumatlarını yeniləyin." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: EditAd,
});

function EditAd() {
  const { id } = Route.useParams();
  const { user } = Route.useRouteContext();

  const adminQuery = useQuery({
    queryKey: ["is-admin", user.id],
    queryFn: () => isAdmin(user.id),
  });

  const { data, isLoading } = useQuery({
    queryKey: ["listing", id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("listings")
        .select(
          "id, user_id, title, description, price, negotiable, category, city, phone, whatsapp, images, badge, status, views, created_at, badge_expires_at, badge_price, specs",
        )
        .eq("id", id)
        .maybeSingle();
      if (error) throw error;
      return (data as ListingRow | null) ?? null;
    },
  });

  if (isLoading || adminQuery.isLoading) {
    return (
      <div className="container-x grid place-items-center py-24">
        <Loader2 className="size-6 animate-spin text-primary" />
      </div>
    );
  }

  const admin = adminQuery.data === true;

  if (!data || (data.user_id !== user.id && !admin)) {
    return (
      <div className="container-x py-24 text-center">
        <h1 className="text-2xl font-extrabold">Elan tapılmadı</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Bu elan silinib və ya sizə aid deyil.
        </p>
        <Link to="/profil">
          <Button className="mt-5 rounded-full">Profilə qayıt</Button>
        </Link>
      </div>
    );
  }

  const adminEditing = admin && data.user_id !== user.id;

  return (
    <div className="container-x max-w-3xl py-10">
      <h1 className="text-3xl font-extrabold tracking-tight">Elanı redaktə et</h1>
      <p className="mt-1 text-sm text-muted-foreground">
        {adminEditing
          ? "Admin rejimi: dəyişikliklər dərhal dərc olunur."
          : "Dəyişiklikləri yadda saxlayın."}
      </p>
      <ListingForm userId={data.user_id} listing={data} adminMode={adminEditing} />
    </div>
  );
}
